import { Echo } from './echo.model';

export class Echos<T= string> {
    info: any;

    constructor(public title: string,
        public echos: Echo<T>[]) {
    }
}
